var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{attrs:{"items":_vm.countries,"prepend-icon":"mdi-magnify","append-icon":""},on:{"change":_vm.sendRequest},model:{value:(_vm.country),callback:function ($$v) {_vm.country=$$v},expression:"country"}})}
var staticRenderFns = []

export { render, staticRenderFns }